/* eslint-disable */
import { Chip } from '@material-ui/core';
import styled from 'styled-components';

const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 16px;
  overflow: hidden;
  background: #fff;
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const SectionTitle = styled.span`
  text-transform: uppercase;
  font-size: 1rem;
  font-weight: bold;
`;

const Lines = styled.div`
  display: flex;
  flex-direction: column;
`;

const Line = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const Label = styled.span`
  font-weight: 600;
`;

const InfoLine = ({ label = '', value = '', meta = null }) => (
  <Line>
    <Label>{label}:</Label>
    <span>{value}</span>
    {meta && (
      <Chip
        label={meta}
        style={{
          backgroundColor: '#F26522',
          color: '#fff',
          fontWeight: 600,
          fontSize: '0.85rem',
          marginLeft: 4,
          height: 25,
        }}
      />
    )}
  </Line>
);

const FiIndicationSummary = ({ summary = null }) => {
  if (!summary) return null;

  return (
    <Card>
      {Object.values(summary).map((section, sectionIndex) => (
        <Section key={`indication-summary-section-${sectionIndex}`}>
          <SectionTitle>{section?.label}</SectionTitle>

          <Lines>
            {section?.rows?.map((row, rowIndex) => (
              <InfoLine
                key={`indication-summary-row-${sectionIndex}-${rowIndex}`}
                label={row?.label}
                value={row?.value}
                meta={row?.meta}
              />
            ))}
          </Lines>
        </Section>
      ))}
    </Card>
  );
};

export default FiIndicationSummary;
